import { render, staticRenderFns } from "./ouItemMMOX.vue?vue&type=template&id=e8e26bdc&lang=pug&"
import script from "./ouItemMMOX.vue?vue&type=script&lang=js&"
export * from "./ouItemMMOX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports